import SingleEventPage from "../../components/single-event-page/SingleEventPage";
import SquidGameImg from "../../assets/event-images/squid.jpg";

const squidGame = {
  image: SquidGameImg,
  description:
    "Squid Game Events are a series of thrilling challenges inspired by classic childhood games, testing participants' skills, strategy, and survival instincts. Each game brings unique rules, eliminations, and opportunities to win!",
  type: "Non Technical Event",
  eventName: "Squid Game",
  dateTime: "Feb 28, 02:00PM - 04:00PM",
  venue: "IT-207",
  rules: [
    "Participants must adhere to the instructions provided for each game.",
    "Eliminations occur if a player fails to meet the game’s requirements or breaks the rules.",
    "All materials provided during the game (cards, dice, marbles, etc.) must be used as intended.",
    "Players must complete tasks or challenges within the given time limits.",
    "Cheating or tampering with game equipment will result in immediate disqualification.",
    "Respect fellow participants and maintain sportsmanship throughout the event.",
    "Decisions made by the organizers and judges are final.",
  ],

  firstprize: 2000,
  secondprize: 0,
  thirdprize: 0,
  contact: [
    {
      name: "Akaash C",
      phoneNo: "8838757307",
    },
    {
      name: "Gokulan N",
      phoneNo: "6382935090",
    },
  ],
};

const SquidGame = () => {
  return <SingleEventPage eventDetails={squidGame} />;
};

export default SquidGame;
